import ToppingItemOptimized, { OnToppingItemChangeProps } from './ToppingItemOptimized';

export type { OnToppingItemChangeProps };
export default ToppingItemOptimized;
